@if (loading()) {
  <app-loading />
} @else {
  <app-step-dot-menu
    [projectId]="projectId()!"
    testId="step4-3-dot-menu-button"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.EVALUATION_CRITERIA_OVERVIEW]"
  ></app-step-dot-menu>

  @if (hasCriteria()) {
    <div class="card mt-5" data-testid="criteria-weights-overview-page">
      <div class="flex flex-wrap justify-between items-center gap-4 mb-6">
        <h2 class="text-xl font-bold">
          {{ 'project.steps.criteriaWeightsOverview.title' | transloco }}
        </h2>

        <p-selectButton
          optionValue="value"
          [options]="viewOptions"
          [allowEmpty]="false"
          [ngModel]="view()"
          data-testid="criteria-weights-overview-view"
          (ngModelChange)="view.set($event)"
        >
          <ng-template #item let-option>
            <span
              class="flex items-center gap-2"
              [attr.data-testid]="'criteria-weights-overview-view-' + option.value"
            >
              <i [class]="option.icon"></i>
              <span class="hidden sm:inline">{{ option.translationKey | transloco }}</span>
            </span>
          </ng-template>
        </p-selectButton>
      </div>

      @if (showsIncompleteWeightsHint()) {
        <p-message
          severity="secondary"
          styleClass="mb-6"
          icon="pi pi-info-circle"
          data-testid="criteria-weights-overview-incomplete-hint"
        >
          {{ 'project.steps.criteriaWeightsOverview.incompleteWeightsHint' | transloco }}
        </p-message>
      }

      @switch (view()) {
        @case ('tree') {
          <app-criteria-weights-tree-chart
            testId="criteria-weights-overview-tree"
            [criteria]="criteria()"
          />
        }
        @case ('treemap') {
          <app-criteria-weights-treemap
            testId="criteria-weights-overview-treemap"
            [criteria]="criteria()"
          />
        }
        @default {
          <app-criteria-weights-table
            testId="criteria-weights-overview-table"
            [criteria]="criteria()"
          />
        }
      }
    </div>
  } @else {
    <div class="card mt-5 text-center py-12" data-testid="criteria-weights-overview-no-criteria">
      <i class="pi pi-info-circle text-4xl mb-4"></i>
      <h3 class="text-lg font-semibold mb-2">
        {{ 'project.steps.noCriteriaTitle' | transloco }}
      </h3>
      <p class="max-w-md mx-auto">{{ 'project.steps.noCriteriaMessage' | transloco }}</p>
    </div>
  }
}
